export type AudioPath = `/audio/${string}.mp3`;

export const slugBlogAudioFileMap: { [x: string]: AudioPath } = {
  'instagram-action-block': '/audio/instagram-action-block.mp3',
};
